import React from 'react';
import { useTranslation } from 'react-i18next';

import IconRewards from '@/assets/icons/heroIcons/Rewards.svg';
import IconPackages from '@/assets/icons/heroIcons/Packages.svg';
import { SectionHeadline } from '@/components/SectionHeadline';
import { ProductBox } from '@/components/boxes';
import { Text } from '@/components/typography';
import { LINKS } from '@/constants/links';
import { mergeClasses } from '@/utils/style';

export function AccountsAndRewards({ className }: { className?: string }) {
	const { t } = useTranslation('core');

	return (
		<div className={mergeClasses('mx-auto w-full max-w-[50rem] px-4', className)}>
			<SectionHeadline className="mb-5 whitespace-nowrap" anchorKey="core.accountsAndRewards.title">
				{t('accountsAndRewards.title')}
			</SectionHeadline>
			<Text variant="p2" className="mb-12 text-center text-gray-800 lg:mb-16">
				{t('accountsAndRewards.text')}
			</Text>

			<div className="flex flex-col gap-4 md:flex-row md:gap-8">
				<div className="w-full">
					<ProductBox
						icon={<IconPackages />}
						title={t('accountsAndRewards.accounts.title')}
						description={t('accountsAndRewards.accounts.text')}
						link={{
							to: LINKS().packages,
							testId: 'packagesAndRewards',
							analyticsParam: 'packagesAndRewards',
						}}
						variant="inverted"
					/>
				</div>
				<div className="w-full">
					<ProductBox
						icon={<IconRewards />}
						title={t('accountsAndRewards.rewards.title')}
						description={t('accountsAndRewards.rewards.text')}
						link={{
							to: LINKS().rewards,
							testId: 'packagesAndRewards',
							analyticsParam: 'packagesAndRewards',
						}}
						variant="inverted"
					/>
				</div>
			</div>
		</div>
	);
}
